var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "overflow-y": "hidden" } },
    [
      _c(
        "div",
        { staticClass: "report_query_box" },
        [
          _vm.searchDateRangeShow
            ? _c(
                "div",
                { staticClass: "item_box" },
                [
                  _c("span", [_vm._v("日期：")]),
                  _c("a-range-picker", {
                    staticStyle: { width: "350px" },
                    attrs: {
                      "default-value": _vm.dateDefaultDate,
                      format: _vm.dateFormat,
                    },
                    on: { change: _vm.onChangeDate },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "item_box" },
            [
              _c("span", [_vm._v("品系：")]),
              _c("a-select", {
                staticStyle: { width: "150px" },
                attrs: { options: _vm.strainOptions },
                model: {
                  value: _vm.search.activityStrain,
                  callback: function ($$v) {
                    _vm.$set(_vm.search, "activityStrain", $$v)
                  },
                  expression: "search.activityStrain",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "item_box" },
            [
              _c("span", [_vm._v("经销商：")]),
              _c("a-select", {
                staticStyle: { width: "150px" },
                attrs: { options: _vm.regionOptions },
                model: {
                  value: _vm.search.regionId,
                  callback: function ($$v) {
                    _vm.$set(_vm.search, "regionId", $$v)
                  },
                  expression: "search.regionId",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "item_box" },
            [
              _c("span", [_vm._v("经理部：")]),
              _c("a-select", {
                staticStyle: { width: "150px" },
                attrs: { options: _vm.dealerOptions },
                model: {
                  value: _vm.search.dealerId,
                  callback: function ($$v) {
                    _vm.$set(_vm.search, "dealerId", $$v)
                  },
                  expression: "search.dealerId",
                },
              }),
            ],
            1
          ),
          _c(
            "a-button",
            {
              staticClass: "func_btn_item",
              attrs: { type: "primary" },
              on: { click: _vm.searchData },
            },
            [_vm._v("筛选")]
          ),
          _c(
            "a-button",
            { staticClass: "func_btn_item", on: { click: _vm.resetData } },
            [_vm._v("重置")]
          ),
          _c(
            "a-button",
            {
              staticClass: "func_btn_item",
              attrs: { type: "primary" },
              on: { click: _vm.exportData },
            },
            [_vm._v("导出")]
          ),
        ],
        1
      ),
      _c("a-table", {
        attrs: {
          columns: _vm.columns,
          "data-source": _vm.tableData,
          pagination: _vm.pagination,
          bordered: "",
          loading: _vm.loading,
          size: "middle",
          scroll: { x: "calc(700px + 50%)", y: 600 },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }